import { render, staticRenderFns } from "./LearnWaterQuality.vue?vue&type=template&id=365b43be&scoped=true&"
import script from "./LearnWaterQuality.vue?vue&type=script&lang=js&"
export * from "./LearnWaterQuality.vue?vue&type=script&lang=js&"
import style0 from "./LearnWaterQuality.vue?vue&type=style&index=0&id=365b43be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b43be",
  null
  
)

export default component.exports